import { useEffect, useRef } from "react";
import { useAtom } from "jotai";
import { expensesAtom } from "@/store/global";
import type { ExpenseWithRequiredCategory } from "@/store/global";
import { useMounted } from "@mantine/hooks";

export function useStorageMigrationIdb() {
  const [{ expenses }, setExpenses] = useAtom(expensesAtom);
  const isMounted = useMounted();

  useEffect(() => {
    const migrateData = () => {
      const localStorageData = localStorage.getItem("expenses");

      if (isMounted && localStorageData) {
        try {
          const parsedData = JSON.parse(localStorageData) as ExpenseWithRequiredCategory[];

          setExpenses((draft) => {
            const currentIds = new Set(draft.expenses.map((e) => e.id));
            const newExpenses = parsedData.filter((e) => !currentIds.has(e.id));

            draft.expenses.push(...newExpenses);
          });

          // move to other key as backup
          localStorage.setItem("expenses-backup", localStorageData);

          console.log("Data migrated from localStorage to IndexedDB");
        } catch (error) {
          console.error("Error parsing localStorage data:", error);
        }
      }
    };

    // TODO: remove the key if already stable
    if (localStorage.getItem("expenses-backup")) {
      if (window.localStorage.getItem("expenses")) {
        localStorage.removeItem("expenses");
        window.posthog?.capture?.("storage-migrated");
      }
    }

    migrateData();
  }, [isMounted, expenses]);
}
